import React, { Component, createRef } from 'react';
import MetaTags from 'react-meta-tags';
import {
  FaChevronRight, FaPlusCircle, FaSortAmountDown, FaArrowUp,
} from 'react-icons/fa';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import {
  categories as categoriesPortal, addNewMaterial, editMaterial, deleteMaterial,
} from '../../queries';

import Category from './Category';
import NewCategoryModal from '../../components/Modal/Products/Category/New';
import EditCategoryModal from '../../components/Modal/Products/Category/Edit';
import ConfirmCategoryModal from '../../components/Modal/Products/Category/Edit/Confirm';
import AddMaterialModal from '../../components/Modal/Products/Product';
import ReorderCategoryModal from '../../components/Modal/Products/Category/Reorder';
import Loading from '../../components/Loading/Page';
import Footer from '../../components/Footer';

import Content from './styles';
import {
  Breadcrumb, Wrapper, EmptyList, ScrollTop,
} from '../../assets/styles';

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoriesList: [],
      newCategoryModal: false,
      reorderCategoryModal: false,
      editCategoryModal: false,
      confirmCategoryModal: false,
      materialModal: false,
      isLoading: true,
      scrolling: false,
    };
    this.bottomRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate = () => {
    if (!this.props.data.loading && this.state.isLoading) {
      const categories = this.props.data.categoriesPortal;

      if (categories.length !== 0) {
        categories.forEach((category) => {
          this.setState(state => ({
            categoriesList: [
              ...state.categoriesList,
              { value: category.id, label: category.name },
            ],
          }));
        });
      }

      this.setState({ isLoading: false });
    }
  }

  handleCategoriesList = async (categories) => {
    await this.setState({ categoriesList: [] });

    categories.forEach((category) => {
      this.setState(state => ({
        categoriesList: [
          ...state.categoriesList,
          { value: category.id, label: category.name },
        ],
      }));
    });
  }

  handleScroll = () => {
    if (window.scrollY < 300 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY > 300 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  scrollToBottom = () => {
    setTimeout(() => {
      this.bottomRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 800);
  }

  openReorderCategoryModal = () => {
    this.reorderCategoryModal.openReorderCategoryModal(this.state.categoriesList);

    this.setState({ reorderCategoryModal: true });
  };

  closeReorderCategoryModal = () => {
    this.setState({ reorderCategoryModal: false });
  };

  openNewCategoryModal = () => {
    this.newCategoryModal.openNewCategoryModal();

    this.setState({ newCategoryModal: true });
  };

  closeNewCategoryModal = () => {
    this.setState({ newCategoryModal: false });
  };

  openEditCategoryModal = (id, category, visible) => {
    this.editCategoryModal.openEditCategoryModal(id, category, visible);

    this.setState({ editCategoryModal: true });
  };

  closeEditCategoryModal = () => {
    this.setState({ editCategoryModal: false });
  };

  openConfirmCategoryModal = (categoryId) => {
    this.confirmCategoryModal.openConfirmCategoryModal(categoryId);

    this.setState({ confirmCategoryModal: true });
  };

  closeConfirmCategoryModal = () => {
    this.setState({ confirmCategoryModal: false });
  };

  openAddMaterialModal = (id, category) => {
    this.materialModal.openAddMaterialModal(id, category);

    this.setState({ materialModal: true });
  };

  openEditMaterialModal = (item) => {
    this.materialModal.openEditMaterialModal(item);

    this.setState({ materialModal: true });
  };

  closeMaterialModal = () => {
    this.setState({ materialModal: false });
  };

  render() {
    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Materiais - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <h2>Materiais</h2>
            <FaChevronRight className="fa fa-chevron-right" />
            <h2 className="bold">Resumo</h2>
          </div>
        </Breadcrumb>
        <Wrapper>
          {this.props.data.loading && <Loading />}
          {!this.props.data.loading && (
          <>
            <Content>
              <div className="filters">
                <button type="button" onClick={this.openNewCategoryModal}>
                  <FaPlusCircle className="fa fa-plus-circle" />
                  <span>Adicionar categoria</span>
                </button>
                {this.props.data.categoriesPortal.length !== 0 && (
                  <button type="button" onClick={this.openReorderCategoryModal}>
                    <FaSortAmountDown className="fa fa-sort-amount-down" />
                    <span>Reordenar categorias</span>
                  </button>
                )}
              </div>
              {this.props.data.categoriesPortal.length === 0 ? (
                <EmptyList>
                  <p>Nenhum material encontrado</p>
                </EmptyList>
              ) : (
                <>
                  {this.props.data.categoriesPortal.map(item => (
                    <Category
                      key={item.id}
                      id={item.id}
                      item={item}
                      addMaterial={this.openAddMaterialModal}
                      editMaterial={this.openEditMaterialModal}
                      editCategory={this.openEditCategoryModal}
                    />
                  ))}
                </>
              )}
              <div className="filters bottom-filter">
                <button type="button" onClick={this.openNewCategoryModal}>
                  <FaPlusCircle className="fa fa-plus-circle" />
                  <span>Adicionar categoria</span>
                </button>
                {this.props.data.categoriesPortal.length !== 0 && (
                  <button type="button" onClick={this.openReorderCategoryModal}>
                    <FaSortAmountDown className="fa fa-sort-amount-down" />
                    <span>Reordenar categorias</span>
                  </button>
                )}
              </div>
              <div ref={this.bottomRef} />
            </Content>
          </>
          )}
          <Footer />
        </Wrapper>
        {this.state.scrolling && (
          <ScrollTop onClick={this.scrollToTop}>
            <FaArrowUp className="fa fa-arrow-up" />
            <span>Topo</span>
          </ScrollTop>
        )}
        <NewCategoryModal
          ref={(el) => { if (el) this.newCategoryModal = el.getWrappedInstance(); }}
          open={this.state.newCategoryModal}
          close={this.closeNewCategoryModal}
          storeId={this.props.store.id}
          position={this.props.data.categoriesPortal && this.props.data.categoriesPortal.length}
          scrollToBottom={this.scrollToBottom}
          handleCategoriesList={this.handleCategoriesList}
        />
        <ReorderCategoryModal
          ref={(el) => { if (el) this.reorderCategoryModal = el.getWrappedInstance(); }}
          open={this.state.reorderCategoryModal}
          close={this.closeReorderCategoryModal}
          storeId={this.props.store.id}
          handleCategoriesList={this.handleCategoriesList}
        />
        <EditCategoryModal
          ref={(el) => { if (el) this.editCategoryModal = el.getWrappedInstance(); }}
          open={this.state.editCategoryModal}
          close={this.closeEditCategoryModal}
          storeId={this.props.store.id}
          handleCategoriesList={this.handleCategoriesList}
          deleteCategory={this.openConfirmCategoryModal}
        />
        <ConfirmCategoryModal
          ref={(el) => { if (el) this.confirmCategoryModal = el.getWrappedInstance(); }}
          open={this.state.confirmCategoryModal}
          close={this.closeConfirmCategoryModal}
          closeEditCategoryModal={this.closeEditCategoryModal}
          handleCategoriesList={this.handleCategoriesList}
          storeId={this.props.store.id}
        />
        <AddMaterialModal
          ref={(el) => { if (el) this.materialModal = el.getWrappedInstance(); }}
          open={this.state.materialModal}
          close={this.closeMaterialModal}
          categories={this.state.categoriesList}
          storeId={this.props.store.id}
          addNewMaterial={this.props.addNewMaterial}
          editMaterial={this.props.editMaterial}
          deleteMaterial={this.props.deleteMaterial}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store,
});

export default compose(
  connect(mapStateToProps, null),
  withAlert(),
  graphql(categoriesPortal, {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: { storeId: props.store.id },
    }),
  }),
  graphql(addNewMaterial, { name: 'addNewMaterial' }),
  graphql(editMaterial, { name: 'editMaterial' }),
  graphql(deleteMaterial, { name: 'deleteMaterial' }),
)(Products);
